import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _wrapNativeSuper from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import errors from '../errors';
var TEN_SECONDS_MS = 10 * 1000;

var RequestError = /*#__PURE__*/function (_Error) {
  _inherits(RequestError, _Error);

  var _super = _createSuper(RequestError);

  function RequestError(data, status, statusText) {
    var _this;

    _classCallCheck(this, RequestError);

    for (var _len = arguments.length, params = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      params[_key - 3] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this, data, status, statusText].concat(params));
    _this.response = {
      data: data,
      status: status,
      statusText: statusText
    };
    _this.message = 'Request failed with status code ' + status;
    return _this;
  }

  return RequestError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var TimeoutError = /*#__PURE__*/function (_Error2) {
  _inherits(TimeoutError, _Error2);

  var _super2 = _createSuper(TimeoutError);

  function TimeoutError(timeout) {
    var _this2;

    _classCallCheck(this, TimeoutError);

    for (var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      params[_key2 - 1] = arguments[_key2];
    }

    _this2 = _super2.call.apply(_super2, [this, timeout].concat(params));
    _this2.message = "timeout of ".concat(timeout, "ms exceeded");
    return _this2;
  }

  return TimeoutError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var handleResponse = function handleResponse(xhr, resolve, reject) {
  var response;

  try {
    response = JSON.parse(xhr.response);
  } catch (_unused) {
    response = xhr.response;
  }

  if (xhr.status >= 200 && xhr.status < 300) {
    resolve(response);
  } else {
    reject(new RequestError(response, xhr.status, xhr.statusText));
  }
};

export var processXhr = function processXhr(xhr, resolve, reject) {
  var timeout = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : TEN_SECONDS_MS;
  xhr.timeout = timeout;

  xhr.onload = function () {
    return handleResponse(xhr, resolve, reject);
  };

  xhr.onerror = function () {
    return reject(new errors.ServiceUnavailable());
  };

  xhr.ontimeout = function () {
    return reject(new TimeoutError(timeout));
  };
};